import DelayedIcon from './component'

export default DelayedIcon
